import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/hivec-video-1.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};




const HealthyBladder = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
 
<h2>Уротелиален карцином на пикочния мехур</h2>
<p>Уротелиалният карцином на пикочния мехур е често срещан вид рак, който обикновено се появява при жени и мъже на възраст над 70 години. Само в Германия всяка година се диагностицират близо 15 850 нови случая.</p>
<h3>Симптоми</h3>
<p>Най-честият симптом на рак на пикочния мехур е безболезнена, видима кръв в урината. Дори и да няма видими признаци на кръв, наличието на най-малките следи от кръв в урината може да бъде установено чрез чувствителни тестове, което налага извършването на допълнителни урологични прегледи.</p>
<h3>Риск фактори</h3>
<p>Рисковите фактори за рак на пикочния мехур включват хронични инфекции на пикочния мехур, тютюнопушене, някои лекарства, контакт с различни химикали и шистозомиаза (паразитно заболяване на пикочните пътища, често след живот в тропически райони).</p>
<h3>Диагностика</h3>
<p>При съмнение за тумор на пикочния мехур се извършва цистоскопия под местна анестезия. Видимите тумори обикновено се отстраняват незабавно, а тъканта се оценява под микроскоп, за да се определи дълбочината на проникване и поведението на клетките. Микроскопското изследване на урината също е важен диагностичен инструмент поради високата си точност при някои карциноми. За изясняване на горните пикочни пътища се извършва съпътстваща оценка с помощта на ехография, последвана от компютърна томография на корема с фаза на дренаж в зависимост от резултатите.</p>
<h3>Лечение</h3>
<p>Прецизната диагностика на тъканите е от съществено значение за оптималното лечение. Туморната тъкан се отстранява и в зависимост от стадия и вида на тумора се взема решение за по-нататъшно лечение. Може да се обмислят локални процедури, като имунотерапия или химиотерапия, комбинирана с хипертермия (ХИВЕК), за да се намали рискът от рецидив. Терапията HIVEC може да бъде извършена в нашата урологична практика в локацията ни в Зекенхайм-Манхайм. По-напредналите тумори обикновено изискват по-агресивно лечение, което може да включва химиотерапия или пълно отстраняване на пикочния мехур.</p>
<h3>Последващи грижи</h3>
<p>Препоръките за проследяване след лечение на рак на пикочния мехур се основават на стадия на тумора. Препоръчва се редовна цистоскопия, а при среден и по-висок риск от рецидив - изследване на урината. Извършването на образни изследвания чрез урография, компютърна томография или ядрено-магнитен резонанс редовно се отказва при високорисковата група. 
                        </p>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
 
<h2>Urothelial Carcinoma of the Urinary Bladder</h2>
<p>Urothelial carcinoma of the urinary bladder is a common type of cancer that usually occurs in women and men over the age of 70. In Germany alone, nearly 15,850 new cases are diagnosed every year.</p>
<h3>Symptoms</h3>
<p>The most common symptom of bladder cancer is painless, visible blood in the urine. Even if there are no visible signs of blood, the presence of the smallest traces of blood in the urine can be detected by sensitive tests, making it necessary to undergo further urological examinations.</p>
<h3>Risk Factors</h3>
<p>The risk factors for bladder cancer include chronic bladder infections, smoking, certain medications, contact with various chemicals, and schistosomiasis (a parasitic disease of the urinary tract, often after living in tropical areas).</p>
<h3>Diagnostics</h3>
<p>If a bladder tumor is suspected, a cystoscopy is performed under local anesthesia. Visible tumors are usually removed immediately, and the tissue is evaluated under a microscope to determine the depth of penetration and cell behavior. Microscopic urine examination is also an important diagnostic tool due to its high accuracy in certain carcinomas. For clarification of the upper urinary tract, a co-evaluation by means of sonography is performed, followed by a CT scan of the abdomen with drainage phase, depending on the findings.</p>
<h3>Treatment</h3>
<p>Precise tissue diagnostics are essential for optimal treatment. The tumor tissue is removed, and depending on the stage and type of the tumor, further treatment is decided. Local procedures such as immunotherapy or chemotherapy combined with hyperthermia (HIVEC) may be considered to reduce the risk of recurrence. HIVEC therapy can be performed in our urology practice at our Seckenheim-Mannheim location. More advanced tumors usually require more aggressive treatment, which may include chemotherapy or complete bladder removal.</p>
<h3>Follow-up Care</h3>
<p>Recommendations for tumor follow-up after treatment of bladder cancer are based on the tumor stage. Regular cystoscopy is recommended, and urinalysis is recommended for intermediate to higher risk recurrence. Imaging by urography, CT or MRI is regularly withheld from the high-risk group. 
                                <hr/>
 
                            </p>
 
                    </div>
                </section>
            )
    }


}

export default HealthyBladder



// WEBPACK FOOTER //
// ./src/Components/HealthyBladder.js